module.exports = __webpack_public_path__ + "img/face-frame.7c49cbe7.svg";